import requestIdleCallback from 'ha/shims/requestIdleCallback';

// window.addEventListener("load") won't be called if it's already triggered
// before callback was added, so we check for ready state as well
export default function loadNonCriticalData(callback: () => void) {
  const wrappedCallback = () => requestIdleCallback(callback);

  if (document.readyState === 'complete') {
    wrappedCallback();
  } else {
    window.addEventListener('load', wrappedCallback, { once: true });
  }
}
